import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChangelogFields from "@Broker/@Modules/clients/board/client-profile/components/timeline/changelog/index.js";
import { isEmpty, kebabCase, map } from "lodash";
import { isCurrentMonth } from "@Shared/utils/helpers/dates";
import { mapGetters } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerTimelineChangelog",
  components: _objectSpread({}, ChangelogFields),
  props: {
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ReferrerStore", ["getReferrerChangeLog"])), {}, {
    validChangelogItems() {
      return map(ChangelogFields, (_, key) => kebabCase(key));
    },
    isEmptyChangelog() {
      return isEmpty(this.changeLog);
    },
    changeLog() {
      const filteredChangelogByKnownType = this.getReferrerChangeLog(this.referrerId);
      return _mapInstanceProperty(filteredChangelogByKnownType).call(filteredChangelogByKnownType, changelog => {
        var _context;
        return _objectSpread(_objectSpread({}, changelog), {}, {
          items: _filterInstanceProperty(_context = changelog.items).call(_context, item => {
            var _context2, _context3;
            const typeToCheck = _includesInstanceProperty(_context2 = item.type).call(_context2, "field") ? "field" : item.type;
            return _includesInstanceProperty(_context3 = this.validChangelogItems).call(_context3, `changelog-${typeToCheck}`);
          })
        });
      });
    }
  }),
  methods: {
    toHyphens(name) {
      return kebabCase(name);
    },
    isCurrentMonth(month) {
      return isCurrentMonth(month);
    },
    insertionTimestampTooltip(timestamp) {
      return this.$options.filters.formatDateHour(timestamp);
    },
    changelogComponent(type) {
      if (_includesInstanceProperty(type).call(type, "field")) return "changelog-field";
      return `changelog-${type}`;
    }
  }
});